import React, { useEffect, useRef, useState } from 'react';
import { Camera } from "lucide-react";
import _ from 'lodash';
import { serverUtilities } from 'services/serverutilities.service';
import ScheduleScreen from './homeshedule';
import { useHistory } from 'react-router-dom';


const HomeScreen = () => {
     const history = useHistory();
  const videoPlayerRef = useRef(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardDataExtra, setDashboardDataExtra] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState('academic');
  const [selectedData, setSelectedData] = useState([]);
  const refRBSheet = useRef();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const result = await serverUtilities.getdashbordData();
        const result1 = await fetch('https://youngminds.pro/olv/mobapp/user/getymappdashboard/123');
        const data1 = await result1.json();
        setData(data1);
        setDashboardData({
          coursesPaid: result.coursesPaid,
          coursesPaid_title: "My Courses",
          coursesDemo: result.coursesDemo,
          coursesDemo_title: "Demo Courses",
          groupInfo: result.groupInfo
        });
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const enterFullScreen = () => {
    setIsFullScreen(true);
    if (videoPlayerRef.current) {
      videoPlayerRef.current.requestFullscreen();
    }
  };

  const exitFullScreen = () => {
    setIsFullScreen(false);
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const gotoCourse = (id, courseName, image) => {
    console.log('Navigate to course:', id, courseName);
      //  history.push(`/subject/${id}`);
      history.push({
  pathname: `/subject/${id}`,
  state: { id, courseName}
});
    

  };

  const gotoYoutube = (all, videoUrl) => {
    window.open(videoUrl, '_blank');
  };

  const openWebView = (url) => {
    window.open(url, '_blank');
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f8fafc'
      }}>
        <div style={{
          fontSize: '1.25rem',
          fontWeight: '600',
          color: '#334155'
        }}>Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f8fafc'
      }}>
        <div style={{
          fontSize: '1.25rem',
          fontWeight: '600',
          color: '#dc2626'
        }}>Error: {error}</div>
      </div>
    );
  }

  const renderRightSideContent = () => {
    return (
      <div style={{ 
        width: '32%', 
        paddingLeft: '24px',
        position: 'sticky',
        top: '20px',
        alignSelf: 'flex-start'
      }}>
        <ScheduleScreen navigation={''} data={data}/>

     
      </div>
    );
  };

  const renderMobileRelatedVideos = () => {
    return (
      <div style={{ 
        margin: '24px 0',
        padding: '0 16px'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '600',
          marginBottom: '16px',
          color: '#1e293b'
        }}>Related Videos</h2>
        <div style={{
          display: 'flex',
          gap: '16px',
          overflowX: 'auto',
          paddingBottom: '16px',
          scrollbarWidth: 'none',
          '::-webkit-scrollbar': {
            display: 'none'
          }
        }}>
          {data?.yt_vids?.map((item) => (
            <div 
              key={item.yt_url}
              style={{
                flexShrink: 0,
                borderRadius: '12px',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
                cursor: 'pointer',
                transition: 'transform 0.2s ease',
                ':hover': {
                  transform: 'scale(1.02)'
                },
                width: '240px'
              }}
              onClick={() => gotoYoutube(item, item.yt_url)}
            >
              <div style={{
                width: '100%',
                height: '135px',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <img 
                  src={item.yt_thumbnail} 
                  alt={item.yt_title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '8px',
                  right: '8px',
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px'
                }}>
                  ▶ Play
                </div>
              </div>
              <div style={{ padding: '12px' }}>
                <p style={{
                  fontWeight: '600',
                  color: '#1e293b',
                  marginBottom: '4px',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  lineHeight: '1.4',
                  fontSize: '14px'
                }}>{item.yt_title}</p>
                <p style={{
                  color: '#64748b',
                  fontSize: '12px',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  lineHeight: '1.4'
                }}>{item.yt_short_desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderMobileScheduleSection = () => {
    return (
      <div style={{ 
        margin: '24px 0',
        padding: '0 16px'
      }}>
        <ScheduleScreen navigation={''} data={data}/>
      </div>
    );
  };

  const renderMobileBottomPromoBanner = () => {
    if (!data?.promos_last?.banner) return null;
    
    return (
      <div 
        style={{
          margin: '24px 16px',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
          cursor: 'pointer'
        }}
        onClick={() => openWebView(data.promos_last.url)}
      >
        <img 
          src={data.promos_last.banner} 
          alt="Promotion"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        />
      </div>
    );
  };


  console.log('dashboardData?.groupInfo',dashboardData?.groupInfo)
  return (
    <div style={{
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      fontFamily: "'Inter', sans-serif"
    }}>
      {/* Header */}
      <header style={{
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '16px 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <img 
              src="https://youngminds.pro/logo.png" 
              alt="Young Minds Logo" 
              style={{ 
                height: '32px',
                width: 'auto' 
              }}
            />
            <span style={{
              fontWeight: '600',
              color: '#1e293b',
              fontSize: '18px'
            }}>Young Minds</span>
          </div>
          <div style={{ 
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <button style={{
              padding: '8px',
              borderRadius: '50%',
              cursor: 'pointer',
              border: 'none',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s ease',
              ':hover': {
                backgroundColor: '#f1f5f9'
              }
            }}>
              <Camera size={22} style={{ color: '#475569' }} />
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isDesktop ? '24px' : '0'
      }}>
        {isDesktop ? (
          <div style={{ 
            display: 'flex',
            gap: '24px',
            marginTop: '24px'
          }}>
            {/* Left Content */}
            <div style={{ 
              width: '68%',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px'
            }}>
              {/* Video Player */}
              <div style={{
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                backgroundColor: '#ffffff',
                position: 'relative'
              }}>
                <video 
                  ref={videoPlayerRef}
                  controls
                  poster="https://pushsales.b-cdn.net/igp_im1.jpeg"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    aspectRatio: '16/9'
                  }}
                >
                  <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                {!isFullScreen && (
                  <button 
                    style={{
                      position: 'absolute',
                      bottom: '16px',
                      right: '16px',
                      backgroundColor: 'rgba(0, 0, 0, 0.7)',
                      color: 'white',
                      padding: '8px',
                      borderRadius: '50%',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'transform 0.2s ease',
                      ':hover': {
                        transform: 'scale(1.1)'
                      }
                    }}
                    onClick={enterFullScreen}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <polyline points="9 21 3 21 3 15"></polyline>
                      <line x1="21" y1="3" x2="14" y2="10"></line>
                      <line x1="3" y1="21" x2="10" y2="14"></line>
                    </svg>
                  </button>
                )}
              </div>

              {/* My Courses */}
              {dashboardData?.coursesPaid?.Mycourse && dashboardData.coursesPaid.Mycourse.length > 0 && (
                <div style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  padding: '20px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                }}>
                  <h2 style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    marginBottom: '16px',
                    color: '#1e293b'
                  }}>{dashboardData.coursesPaid_title}</h2>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: '16px'
                  }}>
                    {dashboardData.coursesPaid.Mycourse.filter(item => item.courseId !== 0).map((item) => (
                      <div 
                        key={item.courseId}
                        style={{
                          borderRadius: '8px',
                          overflow: 'hidden',
                          backgroundColor: '#ffffff',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                          cursor: 'pointer',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          ':hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)'
                          }
                        }}
                        onClick={() => gotoCourse(item.courseId, item.courseName, item.courseImageUrl)}
                      >
                        <div style={{
                          width: '100%',
                          height: '120px',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <img 
                            src={item.courseImageUrl} 
                            alt={item.courseName}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'strech',
                              transition: 'transform 0.3s ease',
                              ':hover': {
                                transform: 'scale(1.05)'
                              }
                            }}
                          />
                          {/* <div style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
                            padding: '8px',
                            color: 'white',
                            fontSize: '12px',
                            fontWeight: '500'
                          }}>
                            View Course
                          </div> */}
                        </div>
                        <div style={{ padding: '12px' }}>
                          <p style={{
                            fontWeight: '600',
                            color: '#1e293b',
                            marginBottom: '4px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}>{item.courseName}</p>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}>
                            <div style={{
                              width: '16px',
                              height: '16px',
                              backgroundColor: '#3b82f6',
                              borderRadius: '50%'
                            }}></div>
                            <span style={{
                              fontSize: '12px',
                              color: '#64748b'
                            }}>Active</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}


   {/* Group Banner */}


                {data?.promos?.banner && (
                <div style={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                  transition: 'transform 0.2s ease',
                  ':hover': {
                    transform: 'translateY(-2px)'
                  }
                }}>
                  <img 
                    src={data.promos.banner} 
                    alt="Group Banner"
                    style={{
                      width: '100%',
                      height: 'auto',
                      display: 'block'
                    }}
                  />
                </div>
              )}

              {/* Related Videos */}
              {/* {data?.yt_vids?.length > 0 && (
                <div style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  padding: '20px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                }}>
                  <h2 style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    marginBottom: '16px',
                    color: '#1e293b'
                  }}>Related Videos</h2>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '16px'
                  }}>
                    {data.yt_vids.map((item) => (
                      <div 
                        key={item.yt_url}
                        style={{
                          borderRadius: '8px',
                          overflow: 'hidden',
                          backgroundColor: '#1e40af',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                          cursor: 'pointer',
                          transition: 'transform 0.2s ease',
                          ':hover': {
                            transform: 'translateY(-4px)'
                          }
                        }}
                        onClick={() => gotoYoutube(item, item.yt_url)}
                      >
                        <div style={{
                          position: 'relative',
                          width: '100%',
                          height: '160px',
                          overflow: 'hidden'
                        }}>
                          <img 
                            src={item.yt_thumbnail} 
                            alt={item.yt_title}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                          />
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(0, 0, 0, 0.3)',
                            transition: 'background-color 0.2s ease',
                            ':hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.5)'
                            }
                          }}>
                            <div style={{
                              width: '48px',
                              height: '48px',
                              backgroundColor: 'rgba(255, 255, 255, 0.9)',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#dc2626" stroke="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div style={{ padding: '16px' }}>
                          <h3 style={{
                            fontWeight: '600',
                            color: 'white',
                            marginBottom: '8px',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: '1.4',
                            fontSize: '16px'
                          }}>{item.yt_title}</h3>
                          <p style={{
                            color: '#93c5fd',
                            fontSize: '14px',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: '1.4'
                          }}>{item.yt_short_desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )} */}
              
      <div style={{ 
        margin: '24px 0',
        padding: '0 16px'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '600',
          marginBottom: '16px',
          color: '#1e293b'
        }}>Related Videos</h2>
        <div style={{
          display: 'flex',
          gap: '16px',
          overflowX: 'auto',
          paddingBottom: '16px',
          scrollbarWidth: 'none',
          '::-webkit-scrollbar': {
            display: 'none'
          }
        }}>
          {data?.yt_vids?.map((item) => (
            <div 
              key={item.yt_url}
              style={{
                flexShrink: 0,
                borderRadius: '12px',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
                cursor: 'pointer',
                transition: 'transform 0.2s ease',
                ':hover': {
                  transform: 'scale(1.02)'
                },
                width: '240px'
              }}
              onClick={() => gotoYoutube(item, item.yt_url)}
            >
              <div style={{
                width: '100%',
                height: '135px',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <img 
                  src={item.yt_thumbnail} 
                  alt={item.yt_title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '8px',
                  right: '8px',
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px'
                }}>
                  ▶ Play
                </div>
              </div>
              <div style={{ padding: '12px' }}>
                <p style={{
                  fontWeight: '600',
                  color: '#1e293b',
                  marginBottom: '4px',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  lineHeight: '1.4',
                  fontSize: '14px'
                }}>{item.yt_title}</p>
                <p style={{
                  color: '#64748b',
                  fontSize: '12px',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  lineHeight: '1.4'
                }}>{item.yt_short_desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
   

            

              {/* Demo Courses */}
              {dashboardData?.coursesDemo?.demoCourse && 
                dashboardData.coursesDemo.demoCourse.length > 0 && 
                dashboardData.coursesDemo.demoCourse.some(item => item.courseId !== 0) && (
                <div style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  padding: '20px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                }}>
                  <h2 style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    marginBottom: '16px',
                    color: '#1e293b'
                  }}>{dashboardData.coursesDemo_title}</h2>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: '16px'
                  }}>
                    {dashboardData.coursesDemo.demoCourse.filter(item => item.courseId !== 0).map((item) => (
                      <div 
                        key={item.courseId}
                        style={{
                          borderRadius: '8px',
                          overflow: 'hidden',
                          backgroundColor: '#ffffff',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                          cursor: 'pointer',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          ':hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)'
                          }
                        }}
                        onClick={() => gotoCourse(item.courseId, item.courseName, item.courseImageUrl)}
                      >
                        <div style={{
                          width: '100%',
                          height: '120px',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <img 
                            src={item.courseImageUrl} 
                            alt={item.courseName}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              transition: 'transform 0.3s ease',
                              ':hover': {
                                transform: 'scale(1.05)'
                              }
                            }}
                          />
                          <div style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: '#f59e0b',
                            color: 'white',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: '500'
                          }}>
                            Demo
                          </div>
                        </div>
                        <div style={{ padding: '12px' }}>
                          <p style={{
                            fontWeight: '600',
                            color: '#1e293b',
                            marginBottom: '4px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}>{item.courseName}</p>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}>
                            <div style={{
                              width: '16px',
                              height: '16px',
                              backgroundColor: '#f59e0b',
                              borderRadius: '50%'
                            }}></div>
                            <span style={{
                              fontSize: '12px',
                              color: '#64748b'
                            }}>Try Now</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

                 {data?.promos_last?.banner && (
          <div 
            style={{
              marginBottom: '32px',
              cursor: 'pointer',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
              transition: 'transform 0.2s ease',
              ':hover': {
                transform: 'translateY(-2px)'
              }
            }}
            onClick={() => openWebView(data.promos_last.url)}
          >
            <img 
              src={data.promos_last.banner} 
              alt="Promotion"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
          </div>
        )}
            </div>

            {/* Right Sidebar */}
            {renderRightSideContent()}
          </div>
        ) : (
          /* Mobile Layout */
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            paddingBottom: '24px'
          }}>
            {/* Video Player */}
            <div style={{
              position: 'relative',
              backgroundColor: '#ffffff',
              padding: '16px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
            }}>
              <video 
                ref={videoPlayerRef}
                controls
                poster="https://pushsales.b-cdn.net/igp_im1.jpeg"
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  display: 'block'
                }}
              >
                <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              {!isFullScreen && (
                <button 
                  style={{
                    position: 'absolute',
                    bottom: '28px',
                    right: '28px',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    padding: '8px',
                    borderRadius: '50%',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClick={enterFullScreen}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <polyline points="9 21 3 21 3 15"></polyline>
                    <line x1="21" y1="3" x2="14" y2="10"></line>
                    <line x1="3" y1="21" x2="10" y2="14"></line>
                  </svg>
                </button>
              )}
            </div>

            {/* My Courses */}
            {dashboardData?.coursesPaid?.Mycourse && dashboardData.coursesPaid.Mycourse.length > 0 && (
              <div style={{
                backgroundColor: '#ffffff',
                padding: '16px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
              }}>
                <h2 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  marginBottom: '16px',
                  color: '#1e293b'
                }}>{dashboardData.coursesPaid_title}</h2>
                <div style={{
                  display: 'flex',
                  gap: '12px',
                  overflowX: 'auto',
                  paddingBottom: '8px',
                  scrollbarWidth: 'none',
                  '::-webkit-scrollbar': {
                    display: 'none'
                  }
                }}>
                  {dashboardData.coursesPaid.Mycourse.filter(item => item.courseId !== 0).map((item) => (
                    <div 
                      key={item.courseId}
                      style={{
                        flexShrink: 0,
                        width: '160px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
                        cursor: 'pointer'
                      }}
                      onClick={() => gotoCourse(item.courseId, item.courseName, item.courseImageUrl)}
                    >
                      <div style={{
                        width: '100%',
                        height: '100px',
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                        <img 
                          src={item.courseImageUrl} 
                          alt={item.courseName}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      </div>
                      <div style={{ padding: '12px' }}>
                        <p style={{
                          fontWeight: '600',
                          color: '#1e293b',
                          fontSize: '14px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}>{item.courseName}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Banner/Promo */}
            {data?.promos?.banner && (
              <div 
                style={{
                  margin: '0 16px',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
                  cursor: 'pointer'
                }}
                onClick={() => openWebView(data.promos.url)}
              >
                <img 
                  src={data.promos.banner} 
                  alt="Promotion"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </div>
            )}

            {/* Demo Courses */}
            {dashboardData?.coursesDemo?.demoCourse && 
              dashboardData.coursesDemo.demoCourse.length > 0 && 
              dashboardData.coursesDemo.demoCourse.some(item => item.courseId !== 0) && (
              <div style={{
                backgroundColor: '#ffffff',
                padding: '16px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
              }}>
                <h2 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  marginBottom: '16px',
                  color: '#1e293b'
                }}>{dashboardData.coursesDemo_title}</h2>
                <div style={{
                  display: 'flex',
                  gap: '12px',
                  overflowX: 'auto',
                  paddingBottom: '8px',
                  scrollbarWidth: 'none',
                  '::-webkit-scrollbar': {
                    display: 'none'
                  }
                }}>
                  {dashboardData.coursesDemo.demoCourse.filter(item => item.courseId !== 0).map((item) => (
                    <div 
                      key={item.courseId}
                      style={{
                        flexShrink: 0,
                        width: '160px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
                        cursor: 'pointer',
                        position: 'relative'
                      }}
                      onClick={() => gotoCourse(item.courseId, item.courseName, item.courseImageUrl)}
                    >
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        backgroundColor: '#f59e0b',
                        color: 'white',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontWeight: '500',
                        zIndex: 1
                      }}>
                        Demo
                      </div>
                      <div style={{
                        width: '100%',
                        height: '100px',
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                        <img 
                          src={item.courseImageUrl} 
                          alt={item.courseName}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      </div>
                      <div style={{ padding: '12px' }}>
                        <p style={{
                          fontWeight: '600',
                          color: '#1e293b',
                          fontSize: '14px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}>{item.courseName}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Group Banner */}
            {dashboardData?.groupInfo?.bannerImg && (
              <div style={{
                margin: '0 16px',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)'
              }}>
                <img 
                  src={dashboardData.groupInfo.bannerImg} 
                  alt="Group Banner"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </div>
            )}

            {/* Mobile Related Videos */}
            {renderMobileRelatedVideos()}

            {/* Mobile Schedule Section */}
            {renderMobileScheduleSection()}

            {/* Mobile Bottom Promo Banner */}
            {renderMobileBottomPromoBanner()}
          </div>
        )}
      </main>
    </div>
  );
};

export default HomeScreen;